import { createReducer, on, Action } from '@ngrx/store';

import { initialState, State } from './state';

const detailReducer = createReducer(initialState);

export function reducer(state: State | undefined, action: Action): any {
    return detailReducer(state, action);
}
